/**
 * Upcast a value to a more specific type.
 * @param value - The value to upcast.
 * @returns The upcasted value.
 */
/**
 * Checks if a value is an enum value.
 * @param enumType - The enum type to check against.
 * @param value - The value to check.
 * @returns True if the value is an enum value, false otherwise.
 */
export function isEnumValue(enumType, value) {
    const possibleValues = Array.isArray(enumType) ? enumType : Object.values(enumType);
    return possibleValues.includes(value);
}
//# sourceMappingURL=index.js.map